import React, { useState, useEffect, useRef } from "react";
import { Button, Checkbox, Input, Space, Switch, Table } from "antd";
import classes from "./perfiles-master-doc-list.module.scss";
import { SearchOutlined } from "@ant-design/icons";


const MasterDocPerfil = (props) => {
  const {
    disabled,
    restricciones,
    setDocumentosRestriccion,
    documentosList,
    accionesById,
  } = props;

  const [modulos, setModulos] = useState(restricciones);
  const [restriccionDoc, setRestriccionDoc] = useState(documentosList);
  const searchInputRef = useRef(null);

  useEffect(() => {
    setDocumentosRestriccion(restriccionDoc)

  }, [restriccionDoc])

  useEffect(() => {
    restriccionDoc.map((doc) => {
      accionesById.find((a) => {
        if (a.codMasterDoc === doc.codMasterDoc) {
          setRestriccionDoc((prevRestriccionDoc) =>
            prevRestriccionDoc.map((doc) => {
              if (doc.codMasterDoc === a.codMasterDoc) {
                return {
                  ...doc,
                  acciones: a.acciones,
                };
              }
              return doc;
            })
          );
        }
      })
    })

  }, [])

  const handleSwitchChange = (moduleId, actionId, checked) => {
    if (checked) {
      setRestriccionDoc((prevRestriccionDoc) =>
        prevRestriccionDoc.map((doc) => {
          if (doc.id === moduleId) {
            if (checked) {
              return {
                ...doc,
                acciones: [
                  ...doc.acciones,
                  actionId
                ],
              };
            }
          }
          return doc;
        })
      );
    } else {
      setRestriccionDoc((prevRestriccionDoc) =>
        prevRestriccionDoc.map((doc) => {
          if (doc.id === moduleId) {
            if (!checked) {
              return {
                ...doc,
                acciones: doc.acciones.filter((a) => a !== actionId),
              };
            }
          }
          return doc;
        })
      );
    };
  };

  const handleColumnCheckboxChange = (actionId, checked) => {
    setRestriccionDoc((prevRestriccionDoc) =>
      prevRestriccionDoc.map((doc) => {
        if (checked) {
          return {
            ...doc,
            acciones: [...doc.acciones, actionId],
          };
        } else {
          return {
            ...doc,
            acciones: doc.acciones.filter((a) => a !== actionId),
          };
        }
      })
    );
  };

  const columns = [
    {
      title: "Documento",
      dataIndex: "codMasterDoc",
      key: "codMasterDoc",
      filterMode: "",
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
        <div style={{ padding: 8 }}>
          <Input
            ref={searchInputRef} // Assign the ref to the search input
            placeholder="Buscar documento"
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={confirm}
            style={{ width: 188, marginBottom: 8, display: "block", width: "26vh" }}
          />
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Button
              className={classes.searchButton}
              type="tertiary"
              onClick={() => {
                confirm({
                  closeDropdown: true,
                })
              }}
              size="small"
              icon={<SearchOutlined />}
            >
              Filtrar
            </Button>
            <Button
              className={classes.searchButton}
              onClick={clearFilters}
              size="small"
            >
              Reset
            </Button>
            <Button
              className={classes.searchButton}
              onClick={() => {
                confirm({
                  closeDropdown: true,
                })
              }}
              size="small"
            >
              Cerrar
            </Button>
          </div>
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
      ),
      onFilter: (value, record) =>
        record.codMasterDoc
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
      onFilterDropdownVisibleChange: (visible) => {
        if (visible) {
          setTimeout(() => searchInputRef.current.select(), 100);
        }
      },
      render: (text) => text,
    },
    ...modulos.restricciones.map((accion) => ({
      title: (
        <div className={classes.columnHeader}>
          {accion.nombre.split("-")[1]}
          <br />
          <Checkbox
            style={{ marginLeft: "15px" }}
            onChange={(e) => handleColumnCheckboxChange(accion.id, e.target.checked)}
          />
        </div>
      ),
      dataIndex: accion.nombre,
      key: accion.nombre,
      render: (text, record) => (
        <Space size="middle">
          <Switch
            size="small"
            checked={
              record.acciones.find((a) => a === accion.id) ? true : false
            }

            disabled={disabled}
            onChange={(checked) =>
              handleSwitchChange(record.id, accion.id, checked)
            }
          />
        </Space>
      ),
    })),
  ];

  return (
    <div className={classes.modulo}>
      <Table
        className={classes.table}
        columns={columns}
        dataSource={restriccionDoc.map((doc) => ({
          ...doc,
          key: doc.id,
        }))}
        pagination={false}
        size="small"
        scroll={{ y: 240, x: 640 }}
      />
    </div>
  );
};

export default MasterDocPerfil;
